<template>
  <form name="form-question" id="form-question" class="quiz-form" novalidate @submit="onSubmit">
    <input type="hidden" name="id" v-model="model.id">
    <input type="hidden" name="pic" v-model="model.image">

    <p class="required-note"><span>*</span> Required fields</p><div v-if="formError" class="form-alert" role="alert">{{ formError }}</div><div class="form-row quiz-details-card">

      <div class="col-md-6">

        <div class="form-group">
          <label for="title">Title <span>*</span></label>
          <InputText class="form-control" v-model="model.title" id="title" :required="true"></InputText>
        </div>

        <div class="form-group">
          <label for="description">Description</label><small class="form-help">Optional context for administrators and participants.</small>
          <InputText class="form-control" v-model="model.description" id="description" :required="true"></InputText>
        </div>

        <div class="form-group">
          <label for="durationPerQuestion">Duration per question (seconds) <span>*</span></label>
          <InputText class="form-control" v-model="model.duration" id="duration" :required="true"></InputText>
        </div>


      </div>

      <div class="col-md-6">
      </div>

      <Divider/>

      <div class="col-md-12">
        <div class="section-heading"><div><p>QUESTION SET</p><h2>Select questions</h2></div><i class="pi pi-list-check" aria-hidden="true"></i></div><p class="form-help mb-3">Choose one or more questions to include in this quiz.</p>
        <Accordion :activeIndex="0">
          <AccordionTab v-for="qc in questionCategories" :key="qc.category" :header="qc.category">

            <div class="form-group question-choice" v-for="question in qc.questions" :key="question.id">
              <div class="align-items-center input-group">
                <Checkbox v-model="model.selectedQuestionIds" :input-id="question.id" name="selectedQuestionIds"
                          :value="question.id"/>
                <label :for="question.id" class="ml-2 mt-2"> {{ question.questionText }} </label>
              </div>
            </div>
          </AccordionTab>
        </Accordion>
      </div>

    </div>

    <Divider/>

    <div class="d-flex justify-content-end mb-sm-1">
      <button type="button" class="btn btn-outline-secondary mr-sm-1" @click="onCancel">Cancel</button>
      <button type="submit" class="btn btn-primary" :disabled="saving">Submit</button>
    </div>

  </form>
</template>
<script>

import {defineComponent} from 'vue'
import apiService from "@/services/ApiService";
import InputText from "primevue/inputtext";
import Checkbox from 'primevue/checkbox';
import Divider from 'primevue/divider';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';

export default defineComponent({
  name: "QuizForm",
  components: {
    InputText, Checkbox, Divider, Accordion, AccordionTab
  },
  props: {
    id: {
      type: String,
      required: false
    },
    isNew: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      model: {
        id: '',
        title: '',
        description: '',
        status: '',
        duration: '',
        selectedQuestionIds: [],
      },
      questionCategories: [
        {
          category: '',
          questions: [{id: '', questionText: '', category: ''}]
        }
      ],
      saving: false, formError: '',
    }
  },
  methods: {
    onSubmit(event) {

            event.preventDefault(); this.formError=''; if(!this.model.title.trim()){this.formError='Quiz title is required.';return;} if(!Number(this.model.duration)||Number(this.model.duration)<1){this.formError='Duration must be greater than 0 seconds.';return;} if(!this.model.selectedQuestionIds.length){this.formError='Select at least one question.';return;}

      this.saving = true;

      let url = '/quiz/edit';
      let successMessage = 'Quiz has been updated';
      let errorMessage = 'Failed to update quiz';
      if (this.isNew) {
        url = '/quiz/add';
        successMessage = 'Quiz has been added';
        errorMessage = 'Failed to add quiz'
      }
      apiService.post(url, this.model)
          .then(() => {
            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: successMessage,
              life: 5000
            });
          })
          .catch(error => {
            console.log(error);
            this.$toast.add({
              severity: 'error',
              summary: errorMessage,
              detail: error.response.data.Message,
              life: 5000
            });
          })
          .finally(() => {
            this.saving = false;
          });
    },
    onUploadSuccess(event) {
      let response = JSON.parse(event.xhr.response);
      console.log(event.xhr.response);

      this.model.image = response.fileName;

      this.$toast.add({
        severity: 'success',
        summary: 'Success',
        detail: 'File uploaded',
        life: 5000
      });
    },
    onUploadError(event) {
      let response = JSON.parse(event.xhr.response);
      console.log();
      this.$toast.add({
        severity: 'error',
        summary: 'Failed to upload file',
        detail: response.Message,
        life: 5000
      });
    },
    getQuizById(id) {
      apiService.get(`/quiz/${id}`)
          .then(response => {
            this.model = response.data;
            console.log(this.model);
            this.model.selectedQuestionIds = [];
            this.model.questions.forEach(question => {
              this.model.selectedQuestionIds.push(question.id);
            });

          }).catch(error => {
        console.log(error);
        this.$toast.add({
          severity: 'error',
          summary: 'Failed to get quiz',
          detail: error.response.Message,
          life: 5000
        });
      });
    },
    loadQuestions() {

      var params = {}

      apiService.get('/quiz/question/group-by-category', {params: params})
          .then(response => {
            this.questionCategories = response.data;
          })
          .catch(error => {
            console.log(error);

            this.$toast.add({
              severity: 'error',
              summary: 'Failed to get question',
              detail: error.response.Message,
              life: 5000
            });
          });

    },
    onCancel() {
      this.$router.push('/quiz')
    },
  },
  mounted() {

    this.loadQuestions();

    if (!this.isNew) {
      this.getQuizById(this.id);
    }
  }
})
</script>

<style scoped>
.quiz-form{max-width:1100px}.required-note{color:#5f6570;font-size:.875rem}.required-note span,.quiz-form label span{color:#c62828;font-weight:700}.form-alert{background:#fff1f1;border:1px solid #f5c2c7;border-radius:.5rem;color:#9d2525;margin-bottom:1rem;padding:.8rem 1rem}.quiz-details-card{background:#fff;border:1px solid #e2e6ec;border-radius:.65rem;box-shadow:0 .15rem .65rem rgba(58,59,69,.05);margin:0 0 1.25rem;padding:1.5rem}.section-heading{align-items:flex-start;border-bottom:1px solid #edf0f4;display:flex;justify-content:space-between;margin-bottom:1rem;padding-bottom:1rem}.section-heading p{color:#426cc6;font-size:.7rem;font-weight:700;letter-spacing:.08em;margin:0 0 .25rem}.section-heading h2{font-size:1.15rem;margin:0}.section-heading>.pi{color:#426cc6;font-size:1.2rem}.form-help{color:#6c757d;display:block;font-size:.78rem}.question-choice{border-bottom:1px solid #edf0f4;padding-bottom:.45rem}

</style>
